import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import RankingBoard from "@/pages/home/components/RankingBoard";
import LatestFeed from "@/pages/home/components/LatestFeed";
import SideRail from "@/pages/home/components/SideRail";
import ZoneSection from "@/pages/home/components/ZoneSection";
import CollectionsGrid from "@/pages/home/components/CollectionsGrid";
import TimelineSection from "@/pages/home/components/TimelineSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import { starZoneItems, creatorZoneItems } from "@/mocks/home";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <RankingBoard />

        <section id="today" className="bg-background-50">
          <div className="mx-auto max-w-[1180px] px-4 md:px-6 py-12 md:py-16">
            <div className="grid grid-cols-1 lg:grid-cols-[1.6fr_1fr] gap-8 lg:gap-12">
              <LatestFeed />
              <SideRail />
            </div>
          </div>
        </section>

        <ZoneSection
          id="stars"
          index="01"
          title="明星黑料"
          subtitle="围绕艺人作品、公开行程与工作室回应整理，只呈现可核对的部分。"
          items={starZoneItems}
          tone="primary"
          surface="tint"
        />

        <ZoneSection
          id="creators"
          index="02"
          title="网红黑料"
          subtitle="聚焦博主、主播与短视频达人的争议事件，附平台与当事方的最新动作。"
          items={creatorZoneItems}
          tone="secondary"
        />

        <CollectionsGrid />
        <TimelineSection />
      </main>
      <SiteFooter />
    </div>
  );
}